import ApiService from "@/core/services/api.service";

// action types
export const FETCH_TICKETS = "fetchTickets";
export const FETCH_TICKET = "fetchTicket";
export const STORE_TICKET = "storeTicket";
export const CLOSE_TICKET = "closeTicket";
export const STORE_TICKET_MESSAGE = "storeTicketMessage";
export const GET_TICKET_MESSAGE_FILE_URL = "getTicketMessageFileUrl";
export const UPDATE_TICKET_STATUS = "updateTicketStatus";

// mutation types
export const SET_TICKETS = "setTickets";
export const SET_TICKETS_PAGINATION = "setTicketsPagination";
export const SET_TICKET = "setTicket";

const state = {
  tickets: [],
  ticketsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  ticket: {},
  ticketPriority: {
    1: "عادی",
    2: "فوری",
    3: "بحرانی"
  },
  ticketStatus: {
    1: "باز",
    2: "پاسخ داده شده",
    3: "بسته شده"
  }
};

const getters = {
  tickets(state) {
    return state.tickets;
  },
  ticketsPagination(state) {
    return state.ticketsPagination;
  },
  ticket(state) {
    return state.ticket;
  },
  ticketPriority(state) {
    return state.ticketPriority;
  },
  ticketStatus(state) {
    return state.ticketStatus;
  }
};

const actions = {
  [FETCH_TICKETS](context, payload) {
    let params = {
      page: context.state.ticketsPagination.currentPage,
      priority: payload.priority,
      status: payload.status,
      title: payload.title
    };

    if (payload.userId) {
      params.user = payload.userId;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("tickets", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_TICKETS, data.data);
          context.commit(SET_TICKETS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_TICKET](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`tickets/${id}`)
        .then(({ data }) => {
          context.commit(SET_TICKET, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_TICKET](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("tickets", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_TICKET_MESSAGE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`tickets/${payload.id}/messages`, payload.formData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_TICKET_MESSAGE_FILE_URL](context, path) {
    return new Promise((resolve, reject) => {
      ApiService.query(`tickets/messages/file`, {
        params: {
          path: path
        }
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_TICKET_STATUS](context, payload) {
    // debugger
    return new Promise((resolve, reject) => {
      ApiService.patch(`tickets/${payload.id}/status`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_TICKETS](state, tickets) {
    state.tickets = tickets;
  },
  [SET_TICKETS_PAGINATION](state, data) {
    state.ticketsPagination = data;
  },
  [SET_TICKET](state, ticket) {
    state.ticket = ticket;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
